import MainLayout from "layout/MainLayout";
import { lazy } from "react";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import Profile from "views/profile/index";

const DashboardDefault = Loadable(
  lazy(() => import("views/dashboard/Default"))
);
const AlbumsList = Loadable(lazy(() => import("views/albums/AlbumsList")));
const SubscriptionPage = Loadable(
  lazy(() => import("views/subscriptions/index2"))
); // TODO
const OrdersPage = Loadable(lazy(() => import("views/orders")));
const OrdersListPage = Loadable(lazy(() => import("views/orders/OrdersList")));
const OrderDetails = Loadable(lazy(() => import("views/orders/OrderDetails")));
const PublicProfile = Loadable(
  lazy(() => import("views/dashboard/PublicProfile"))
);
const SuperAthletesPage = Loadable(
  lazy(() => import("views/dashboard/superathletes"))
);
const SuperAthletePage = Loadable(
  lazy(() => import("views/dashboard/superathletes/SuperAthletePage"))
);
const AlbumNew = Loadable(lazy(() => import("views/albums/AlbumNewOrEdit")));
const PackagesPage = Loadable(lazy(() => import("views/packages")));
const ChangelogPage = Loadable(
  lazy(() => import("views/dashboard/ChangelogPage"))
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/dashboard",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/dashboard",
      element: <DashboardDefault />,
    },
    {
      path: "/dashboard/changelog/",
      element: <ChangelogPage />,
    },
    {
      path: "/dashboard/albums/",
      element: <AlbumsList />,
    },
    {
      path: "/dashboard/subscription/",
      element: <SubscriptionPage />,
    },
    {
      path: "/dashboard/orders",
      element: <OrdersPage />,
    },
    {
      path: "/dashboard/orders/list",
      element: <OrdersListPage />,
    },
    {
      path: "/dashboard/orders/:id",
      element: <OrderDetails />,
    },
    {
      path: "/dashboard/packages/",
      element: <PackagesPage />,
    },
    {
      path: "/dashboard/new-album",
      element: <AlbumNew />,
    },
    {
      path: "/dashboard/profile",
      element: <Profile />,
    },
    {
      path: "/dashboard/public-profile",
      element: <PublicProfile />,
    },
    {
      path: "/dashboard/superathletes",
      element: <SuperAthletesPage />,
    },
    {
      path: "/dashboard/superathletes/:id",
      element: <SuperAthletePage />,
    },
  ],
};

export default MainRoutes;
